// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import {  GET_ALL_EMP_TIMESHEET, GET_EACH_EMP_TIMESHEET } from '../../config/API_Collection';
import { getErrorMessage } from '../../config/Error_Codes';
import { GET_EACH_WEEKLY_TS_FAILURE, GET_EACH_WEEKLY_TS_REQUEST, GET_EACH_WEEKLY_TS_SUCCESS, GET_EMP_WEEKLY_TS_FAILURE, GET_EMP_WEEKLY_TS_REQUEST, GET_EMP_WEEKLY_TS_SUCCESS,  } from '../Actions/Actions';



function* fetchTasks({payload}) {
  try {
    const response = yield call(Axios.get,`${GET_EACH_EMP_TIMESHEET}week_no=${payload?.week_no}&emp_id=${payload?.emp_id}`);
    console.warn(response);
    
    const projects = response.data.data || [];
    yield put({type:GET_EACH_WEEKLY_TS_SUCCESS,payload:projects});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:GET_EACH_WEEKLY_TS_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export default function* getEachWeekTimesheetSaga() {
  yield takeLatest(GET_EACH_WEEKLY_TS_REQUEST, fetchTasks);
}
